import axios from "../../utils/axios";

export const getVideos = async (tags, search, page, limit, author) => {
  let queryString = "";

  queryString += `_page=${page}&_limit=${limit}&`;

  if (tags?.length > 0) {
    queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
  }

  if (author !== "") {
    queryString += `&author_like=${author}`;
  }

  if (search !== "") {
    queryString += `&q=${search}`;
  }

  const response = await axios.get(`/videos/?${queryString}`);

  const data = {
    videos: response.data,
    totalVideos: parseInt(response.headers["x-total-count"]) || 0,
  };

  return data;
};
